import { render, staticRenderFns } from "./locations-menu.vue?vue&type=template&id=2a6f54a7"
import script from "./locations-menu.vue?vue&type=script&lang=ts"
export * from "./locations-menu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports